/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

const { Fill, Slot } = createSlotFill( 'Sidebar' );

export { Fill as SidebarFill, Slot as SidebarSlot };
